<template>
  <div
    v-bind:style="showModalInfoMap ? {display: 'block'} : {display: 'none'}"
    class="modal"
    id="exampleModal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-info" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel">Camión :: {{truck.plate}}</h5>
          <button
            @click="close"
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
          <div class="modal-body">

            <table class="table table-bordered table-hover">
              <tbody>
                <tr>
                  <th scope="row">Conductor</th>
                  <td>{{truck.driver ? truck.driver.name : ''}} {{truck.driver ? truck.driver.last_name : ''}}</td>
                </tr>
                <tr>
                  <th scope="row">Celular</th>
                  <td>{{truck.mobile}}</td>
                </tr>
                <tr>
                  <th scope="row">Requerimiento</th>
                  <td>{{ (truck.requeriments && truck.requeriments.length == 0) ? 'Sin servicio asignado' : `${truck.requeriments[0].service.service_type.name} [${truck.requeriments[0].service.doc_number}]`}}</td>
                </tr>
                <tr v-if="truck.requeriments && truck.requeriments.length">
                  <th scope="row">Contenedor</th>
                  <td>{{truck.requeriments[0].container_number ? truck.requeriments[0].container_number : 'No informado'}}</td>
                </tr>
                <tr v-if="truck.requeriments && truck.requeriments.length">
                  <th scope="row">Cliente</th>
                  <td>{{truck.requeriments ? (truck.requeriments[0].service.company ? truck.requeriments[0].service.company.name : '') : ''}}</td>
                </tr>
                <tr v-if="truck.requeriments && truck.requeriments.length && [constants.IMPORTACION, constants.EXPORTACION].includes(truck.requeriments[0].service.service_type.code)">
                  <th scope="row">Destino</th>
                  <td>{{truck.requeriments ? (truck.requeriments[0].address ? truck.requeriments[0].address.alias : '') : ''}}</td>
                </tr>
                <tr v-if="truck.requeriments && truck.requeriments.length && truck.requeriments[0].service.service_type.code === constants.DEVOLUCIONES">
                  <th scope="row">Depósito de devolución</th>
                  <td>{{truck.requeriments && truck.requeriments[0].deposit ? truck.requeriments[0].deposit.name : ''}}</td>
                </tr>
                <tr v-if="truck.requeriments && truck.requeriments.length && truck.requeriments[0].service.service_type.code === constants.EXPORTACION">
                  <th scope="row">Depósito de entrega Full</th>
                  <td>{{truck.requeriments && truck.requeriments[0].deposit ? truck.requeriments[0].deposit.name : ''}}</td>
                </tr>
                <tr v-if="truck.requeriments && truck.requeriments.length && truck.requeriments.length">
                  <th scope="row">Estado</th>
                  <td>{{truck.requeriments ? truck.requeriments[0].status.name : ''}}</td>
                </tr>
              </tbody>
            </table>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
import constants from '@/constants'
export default {
  name: "ModalInfoMap",
  props: ["showModalInfoMap", "truck"],
  data(){
    return {
      constants: {}
    }
  },
  methods: {
    close() {
      this.$emit("close");
    }
  },
  mounted(){
    this.constants = constants
  }
};
</script>